import React from "react";
import { Icon as ChakraIcon, useColorModeValue } from "@chakra-ui/react";
import { IconType } from "react-icons/lib";
import { IconProps } from "@chakra-ui/icon/dist/types/icon";

import { useGetThemeColors } from "ChakraTheme";

interface IProps extends IconProps {
  icon: IconType;
}

const Icon = ({ icon, ...restProps }: IProps) => {
  const colors = useGetThemeColors();
  const color = useColorModeValue(colors.primary[600], colors.gray[200]);
  return <ChakraIcon color={color} {...restProps} as={icon} />;
};

export { Icon };
